__turbopack_context__.v({
  "encryptionSectionContainer": "Encryption-module__oYXGyW__encryptionSectionContainer",
  "imgContainer": "Encryption-module__oYXGyW__imgContainer",
});
